var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurFeature6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 14.8645C16.0156 15.0025 15.6728 15.0737 15.3263 15.0737C14.9798 15.0737 14.637 15.0025 14.3192 14.8645L2.1049 9.20736C1.90656 9.10732 1.73989 8.95419 1.62343 8.76502C1.50697 8.57586 1.44531 8.35807 1.44531 8.13593C1.44531 7.91379 1.50697 7.69601 1.62343 7.50684C1.73989 7.31767 1.90656 7.16454 2.1049 7.0645L14.3192 1.36451C14.637 1.22649 14.9798 1.15527 15.3263 1.15527C15.6728 1.15527 16.0156 1.22649 16.3335 1.36451L28.5478 7.02165C28.7461 7.12169 28.9128 7.27482 29.0292 7.46399C29.1457 7.65315 29.2074 7.87093 29.2074 8.09308C29.2074 8.31522 29.1457 8.533 29.0292 8.72217C28.9128 8.91134 28.7461 9.06447 28.5478 9.1645L16.3335 14.8645Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2546 15.8291L16.1832 21.8505C15.904 21.9779 15.6007 22.0438 15.2939 22.0438C14.987 22.0438 14.6838 21.9779 14.4046 21.8505L1.39746 15.8291",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2546 22.793L16.1832 28.8144C15.904 28.9417 15.6007 29.0076 15.2939 29.0076C14.987 29.0076 14.6838 28.9417 14.4046 28.8144L1.39746 22.793",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.326172 0.0791016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurFeature6);
export default __webpack_public_path__ + "static/media/icon-our-feature-6.9c01d7ff6d262a611172225756308b7c.svg";
export { ForwardRef as ReactComponent };